<template>
  <div class="login">
       <div class="login_content">
          <h3 class="title_">
              后台管理系统
          </h3>
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="">
    			  <el-form-item label="用户" prop="pass">
    			    <el-input type="text" v-model="ruleForm2.pass" autocomplete="off" placeholder="输入账号"></el-input>
    			  </el-form-item>
    			  <el-form-item label="密码" prop="checkPass">
    			    <el-input @keyup.enter.native="submitForm('ruleForm2')" type="password" v-model="ruleForm2.checkPass" autocomplete="off" placeholder="输入密码"></el-input>
    			  </el-form-item>
    			  <el-form-item>
    			    <el-button style="width: 100%;" type="primary" 
                @click="submitForm('ruleForm2')">
                   登录
              </el-button>
    			  </el-form-item>
		     </el-form>
       </div>
  </div>
</template>

<script>
export default{
	name:"login",
	data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户名'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }else {
          callback();
        }
      };
      return {
        ruleForm2: {
          pass: '',
          checkPass: '',
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
        geturl:'./login.php',
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
              this.$http.post(this.geturl,{uname:this.ruleForm2.pass,pass:this.ruleForm2.checkPass},{emulateJSON:true}).then(res=>{
                    if(res.body){
                        sessionStorage.setItem("uname",this.ruleForm2.pass);
                        //路由跳转
                        this.$router.push({path:'/'})
                    }else{
                        //提示消息
                        this.$message.error('用户名或密码错误，请重新输入！');
                    }
              });
          } else {
            console.log('error submit!');
            return false;
          }
        });
      }
    }
}
</script>

<style scoped>
.title_{
  text-align: center;
  border-bottom: 1px dashed #fff;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
.login{
	background: url(./../../static/web_login_bg.jpg) no-repeat;
	background-size: cover;
	width: 100vw;
	height: 100vh;
}
.login_content{
    max-width: 449px;
    min-width: 240px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: url(./../../static/login_bg.png);
    padding: 3% 6% 3% 6%;
    border-radius: 10px;
}
>>> .el-form-item__label {
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue